import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import BooksFormErrorMessage from '../../../../components/books/model1/forms/BooksFormErrorMessage';
import * as IBooks from '../../../../interfaces/merchants/resources/books';

type InnerProps = InjectedIntlProps;

const BlankMessage: React.SFC<InnerProps> = ({ intl }) => (
  <BooksFormErrorMessage>
    {intl.formatMessage({
      id: `books.errors.waitingList.blank`,
      defaultMessage: intl.formatMessage({ id: 'books.errors.blank' }),
    })}
  </BooksFormErrorMessage>
);

const TakenMessage: React.SFC<InnerProps> = ({ intl }) => (
  <BooksFormErrorMessage>
    {intl.formatMessage({
      id: `books.errors.waitingList.taken`,
      defaultMessage: intl.formatMessage({ id: 'books.errors.taken' }),
    })}
  </BooksFormErrorMessage>
);

const InvalidMessage: React.SFC<InnerProps> = ({ intl }) => (
  <BooksFormErrorMessage>
    {intl.formatMessage({
      id: `books.errors.waitingList.invalid`,
      defaultMessage: intl.formatMessage({
        id: 'books.errors.invalid',
      }),
    })}
  </BooksFormErrorMessage>
);

const InvalidDomainMessage: React.SFC<InnerProps> = ({ intl }) => (
  <BooksFormErrorMessage>
    {intl.formatMessage({
      id: `books.errors.waitingList.invalidDomain`,
      defaultMessage: intl.formatMessage({
        id: 'books.errors.invalidDomain',
      }),
    })}
  </BooksFormErrorMessage>
);

const ERROR_COMPONENTS: {
  // tslint:disable-next-line:no-any
  [error in IBooks.ErrorType]: React.ComponentClass;
} = {
  [IBooks.ErrorType.Blank]: injectIntl(BlankMessage),
  [IBooks.ErrorType.Taken]: injectIntl(TakenMessage),
  [IBooks.ErrorType.Invalid]: injectIntl(InvalidMessage),
  [IBooks.ErrorType.InvalidDomain]: injectIntl(InvalidDomainMessage),
  [IBooks.ErrorType.LoginFailed]: injectIntl(InvalidMessage),
};

interface Props {
  errors?: IBooks.ErrorType[];
}

class InputBookingWaitingListErrorMessage extends React.Component<Props> {
  public render() {
    const { errors } = this.props;
    if (!errors) {
      return null;
    }
    if (errors.length === 0) {
      return null;
    }
    return errors.map((error, index) => {
      const Component = ERROR_COMPONENTS[error];
      return <Component key={index} />;
    });
  }
}

export default InputBookingWaitingListErrorMessage;
